var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSideBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 29,
    viewBox: "0 0 25 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.85,
    y: 16.85,
    width: 5.11818,
    height: 11.3,
    rx: 2.55909,
    stroke: "white",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94088 12.4091C9.94088 10.9957 11.0866 9.85 12.5 9.85C13.9133 9.85 15.0591 10.9957 15.0591 12.4091V25.5909C15.0591 27.0043 13.9133 28.15 12.5 28.15C11.0866 28.15 9.94088 27.0043 9.94088 25.5909V12.4091Z",
    stroke: "white",
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.0318,
    y: 0.85,
    width: 5.11818,
    height: 27.3,
    rx: 2.55909,
    stroke: "white",
    strokeWidth: 1.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBar);
export default __webpack_public_path__ + "static/media/side_bar.f05e39b5d7cfcc872be23cbde6a99888.svg";
export { ForwardRef as ReactComponent };